import { FC } from 'react';
import { CloseThin } from '~/components/Icons/fill';
import WifiSecurityOfferStyled from './WifiSecurityStyled';
import Button from '~/components/Button';
import { Modals, Product } from '~/types/products';
interface ScreenProps {
  visible: boolean;
  setActiveModal: (key?: Modals) => void;
  handleSelectProduct?: (product: Product, redirect?: boolean, selectEeroFreeTrial?: boolean) => void;
  selectedProduct?: Product;
}

const WifiSecurityOffer: FC<ScreenProps> = ({ visible, handleSelectProduct, setActiveModal, selectedProduct }) => {
  if (!visible) return null;

  return (
    <WifiSecurityOfferStyled data-testid="modal-wifi-secure">
      <CloseThin
        data-testid="modal-btn-close"
        onClick={() => setActiveModal()}
        className="wifi-secure-offer-screen__close-button"
      />
      <h3 className="wifi-secure-offer-screen__heading">Try Wi-Fi Security on us for one month?</h3>
      <p className="wifi-secure-offer-screen__subheading">
        Don't miss out on protection from online threats with Wi-Fi controls, advanced parental controls and ad-free
        browsing.
        <strong> Try Wi-Fi Security on us for one month, then $5/mo.</strong>
      </p>
      <Button
        className="wifi-secure-offer-screen__btn"
        onClick={() => handleSelectProduct(selectedProduct, true, true)}
      >
        ADD & CONTINUE
      </Button>
      <button
        className="wifi-secure-offer-screen__decline"
        onClick={() => handleSelectProduct(selectedProduct, true, false)}
      >
        No, thanks
      </button>
      <p className="wifi-secure-offer-screen__fine-print">
        After 1 month free trial, Wi-Fi Security will be billed at $5/mo. Cancel anytime via{' '}
        <strong>Frontier Gigachat</strong>. No prorated refunds.
      </p>
    </WifiSecurityOfferStyled>
  );
};

WifiSecurityOffer.displayName = 'WifiSecurityOffer';

export default WifiSecurityOffer;
